module.exports = __webpack_public_path__ + "img/special-prize.358b7830.png";